import React from "react";
import styled from "@emotion/styled";

type Props = {
  value: number;
  /** The largest value on the page; the bar is drawn relative to it. */
  maxValue: number;
  formatValue: (value: number) => string;
};

/** A ranking cell for the measured column: a proportional bar with the value beside it. */
export function MeasureCell({ value, maxValue, formatValue }: Props) {
  const percent = maxValue > 0 ? Math.min(value / maxValue, 1) * 100 : 0;
  return (
    <Cell>
      <Track>
        <Bar style={{ width: `${percent}%` }} />
      </Track>
      <Label>{formatValue(value)}</Label>
    </Cell>
  );
}

const Cell = styled.div({
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) auto",
  alignItems: "center",
  gap: 8,
  width: "100%",
});

const Track = styled.div({
  minWidth: 0,
});

const Bar = styled.div(({ theme }) => ({
  height: 16,
  borderRadius: 4,
  backgroundColor: theme.colors.sysPrimaryDefault,
  opacity: 0.5,
  transition: "width 0.3s ease-in-out",
}));

const Label = styled.span(({ theme }) => ({
  fontSize: 12,
  lineHeight: "20px",
  color: theme.colors.sysTextDefault,
  fontVariantNumeric: "tabular-nums",
  whiteSpace: "nowrap",
}));
